// extracted by mini-css-extract-plugin
module.exports = {"change":"_28WdZ9g1eLZdMI7oOiAGGS"};